// Exporte qualquer variável ou função que queira usar globalmente
const config = {
  ambiente: process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL",
  apiUrl: () => {
    const env = process.env.REACT_APP_ENV?.toUpperCase();
    const apiUrl = process.env[`REACT_APP_API_URL_${env}`];
    return apiUrl;
  },
  portalUrl: () => {
    const env = process.env.REACT_APP_ENV?.toUpperCase();
    const apiUrl = process.env[`REACT_APP_PORTAL_URL_${env}`];
    return apiUrl;
  },
};

export default config;
